var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwichDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.4797 5.23018L6.68975 0.180176H1.07975C0.119748 0.180176 -0.360251 1.34018 0.319749 2.02018L5.49975 7.20018C6.32975 8.03018 7.67975 8.03018 8.50975 7.20018L10.4797 5.23018Z",
    fill: "#2E61D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9204 0.180176H6.69043L10.4804 5.23018L13.6904 2.02018C14.3604 1.34018 13.8804 0.180176 12.9204 0.180176Z",
    fill: "#2E61D6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwichDown);
export default __webpack_public_path__ + "static/media/swich-down.e5a2dc55b59924862a06368e3f1db138.svg";
export { ForwardRef as ReactComponent };